import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-islands',
  templateUrl: './btsprojet.component.html',
  styleUrls: ['./btsprojet.component.css']
})
export class BtsProjetComponent implements OnInit {

  constructor() {}

  ngOnInit(): void {}
}
